export default "__VITE_ASSET__CGEx1KQH__"